import * as XLSX from "xlsx";

/**
 * Exporta un arreglo de objetos a un archivo Excel
 * @param data - Arreglo de objetos a exportar
 * @param fileName - Nombre del archivo Excel (sin extensión)
 * @param sheetName - Nombre de la hoja del Excel (por defecto "Data")
 */
export const exportToExcel = (
  data: any[],
  fileName: string = "export",
  sheetName: string = "Data"
): void => {
  if (!data || data.length === 0) {
    console.warn("No hay datos para exportar");
    return;
  }

  try {
    // Crear un libro de trabajo
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    // Ajustar ancho de columnas automáticamente
    const colWidths = Object.keys(data[0]).map((key) => ({
      wch: Math.max(key.length, 15),
    }));
    worksheet["!cols"] = colWidths;

    // Descargar el archivo
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  } catch (error) {
    console.error("Error al exportar a Excel:", error);
  }
};

/**
 * Exporta un arreglo de objetos a CSV
 * @param data - Arreglo de objetos a exportar
 * @param fileName - Nombre del archivo CSV (sin extensión)
 */
export const exportToCSV = (data: any[], fileName: string = "export"): void => {
  if (!data || data.length === 0) {
    console.warn("No hay datos para exportar");
    return;
  }

  try {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    XLSX.writeFile(workbook, `${fileName}.csv`);
  } catch (error) {
    console.error("Error al exportar a CSV:", error);
  }
};